import http from './http'

const basePath = '/Telas/Pagamento'

export default {
  async getPaged (params) { return (await http.get(`${basePath}/GetPaged`, { params })).data },
  async getById (id) { return (await http.get(`${basePath}/GetById/${id}`)).data },
  async getOptions () { return (await http.get(`${basePath}/GetOptions`)).data }
}
